import commonMixin from "./commonMixin";

const mixin = {
  mixins: [commonMixin],
  methods: {
    RESET_DEFAULT_COLORS(){
      document.documentElement.style.setProperty('--app-primary', '115, 103, 240');
      document.documentElement.style.setProperty('--app-success', '40, 199, 111');
      document.documentElement.style.setProperty('--app-danger', '234, 84, 85');
      document.documentElement.style.setProperty('--app-warning', '255, 159, 67');
    }
  },
  beforeMount(){
    this.RESET_DEFAULT_COLORS();
  }
};

export default mixin;
